<template>
  <div>
    <el-table id="optin-table" :data="channels">
      <el-table-column prop="label" label="Channel" width="180">
        <template slot-scope="scope">
          <social-icon class="fa fa-fw" :type="scope.row.type" />
          {{ scope.row.label }}
        </template>
      </el-table-column>
      <el-table-column prop="optins" align="center" label="Opt-ins" width="180">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.optins" @change="handleChange" />
        </template>
      </el-table-column>
      <el-table-column prop="optouts" align="center" label="Exclude opt-outs" width="180">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.optouts" @change="handleChange" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { get, findIndex } from 'lodash';
import SocialIcon from '@/components/common/Icons/SocialIcon';

export default {
  name: 'OptinFilter',
  components: {
    SocialIcon,
  },
  data: () => ({
    channels: [
      { type: 'email', label: 'Email', optins: false, optouts: true },
      { type: 'sms', label: 'SMS', optins: false, optouts: true },
      { type: 'whatsapp', label: 'WhatsApp', optins: false, optouts: true },
      { type: 'telegram', label: 'Telegram', optins: false, optouts: true },
    ],
  }),
  methods: {
    handleChange() {
      const optins = this.channels.filter(channel => channel.optins).map(channel => channel.type);
      this.$emit('filter', ['meta.opt_in', optins]);

      const optouts = this.channels.filter(channel => channel.optouts).map(channel => channel.type);
      this.$emit('filter', ['meta.opt_out', optouts]);
    },
    reset() {
      this.channels = this.channels.map(c => {
        const channel = c;
        channel.optins = false;
        channel.optouts = true;
        return channel;
      });
      this.handleChange();
    },
    apply(filter) {
      this.clearChannelSelections();
      const optouts = get(filter, 'meta.opt_out', []);
      const optins = get(filter, 'meta.opt_in', []);

      this.applyMechanism(optouts, 'optouts');
      this.applyMechanism(optins, 'optins');
    },
    applyMechanism(selections, mechanism) {
      selections.forEach(channelType => {
        const index = findIndex(this.channels, { type: channelType });
        this.channels[index][mechanism] = true;
      });
    },
    clearChannelSelections() {
      this.channels = this.channels.map(c => {
        const channel = c;
        channel.optins = false;
        channel.optouts = false;
        return channel;
      });
    },
  },
};
</script>

<style scoped>
#optin-table::before {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0px;
}
</style>



// WEBPACK FOOTER //
// OptinsFilter.vue?f083df74